export function sort(targets) {
    const _targets = [].slice.call(document.querySelectorAll(targets));
    if (!_targets || !_targets.length) return false;
    const maxNum = _targets.sort((a, b) => a.offsetHeight - b.offsetHeight)[_targets.length - 1].offsetHeight;
    _targets.forEach(target => target.style.height = maxNum + 'px');
}

export default () => {
    sort('.feature_block_contents .item_head h3');
}